import React from 'react'
import CheckoutbtnCSS from './Checkoutbtn.module.css'

export default function Checkoutbtn() {
  return (
    <>
    <button className={CheckoutbtnCSS.checkout_btn}>🔒 CHECKOUT SECURELY NOW</button>
   </>
  )
}
